import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";

import i18nServerResponse from "../../constants/i18n-server-response";
import { TAlarmsSetOff } from "../../Types";
import { post } from "../axios-post";

export const apiCallTurnOffAlarmData = async (
  AlarmId: number,
  reasonID: number
): Promise<{
  data: TAlarmsSetOff;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TAlarmsSetOff>(
    `developer/turnOffAlarmsData`,
    { AlarmId, reasonID }
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  }
};
